import { React, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Checkbox, Stack, Box, useMediaQuery, useTheme } from '@mui/material';
import NotIcon from '../../asset/circle_XS_Grey.svg';
import OkIcon from '../../asset/check_circle_XS_Green.svg';
import { useGraphContext } from './graphContext';
import SplitText from './../common/SplitText';

const columns = [
  {
    id: 'TARGET COLOR',
    label: 'TARGET COLOR',
    minWidth: '20%',
    align: 'left',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'COLOR CAT.',
    label: 'CAT.',
    minWidth: '12%',
    align: 'left',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'NEAREST',
    label: 'NR',
    minWidth: '12%',
    align: 'left',
  },
  {
    id: 'dE*',
    label: 'dE*',
    minWidth: '12%',
    align: 'left',
  },
  {
    id: 'RESULT',
    label: 'RESULT',
    minWidth: '11%',
    align: 'left',
  },
];

export default function AchievableColorTable(props) {

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm')); // Extra small and small
  const isMd = useMediaQuery(theme.breakpoints.down('md')); // Medium and below
  const isLg = useMediaQuery(theme.breakpoints.up('lg')); // Large and above
  let maxHeight;

  const [selectAll, setSelectAll] = useState(true); // Manage "Select All" checkbox state
  const { togglePointsVisibility } = useGraphContext();
  let rows = props.achievableColorTablerows;
  const [checked, setChecked] = useState(new Array(rows.length).fill(true));

  const handleSelectAllCheckboxChange = (event) => {
    const newCheckedState = event.target.checked;
    setChecked(new Array(rows.length).fill(newCheckedState)); 
    setSelectAll(newCheckedState);
    togglePointsVisibility(event.target.checked);
  };


    // Handle individual checkbox change
  const handleCheckboxChange = (event, index) => {
    const newChecked = [...checked];
    newChecked[index] = event.target.checked; // Update individual checkbox state
    setChecked(newChecked);
    // If any checkbox is unchecked, "Select All" should be unchecked
    setSelectAll(newChecked.every((isChecked) => isChecked));
    togglePointsVisibility(newChecked);
  };


  if (isXs) {
    maxHeight = '584px'; // Adjust for small screens
  } else if (isMd) {
    maxHeight = '584px'; // Adjust for medium screens
  } else if (isLg) {
    maxHeight = '634px'; // Adjust for large screens
  } else {
    maxHeight = '634px'; // Default fallback
  }

  return (
    <TableContainer sx={{maxHeight: maxHeight, minHeight: '634px', border: '2px solid #F0F0F0', borderRadius:'2px' }}>
      <Table stickyHeader aria-label="sticky table">
        <TableHead
          style={{ background: 'var(--LIGHT-GREY, #F0F0F0) !important' }}
        >
          <TableRow>
            <TableCell
              align={'left'}
              sx={{ background: 'var(--LIGHT-GREY, #F0F0F0) !important', padding: '6px'  }}
            >
              <Checkbox 
                id='selectAll checkbox' 
                color="primary"  
                checked={selectAll}
                onChange={handleSelectAllCheckboxChange}/>
            </TableCell>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={'left'}
                style={{ minWidth: column.minWidth }}
                sx={{
                  color: '#303C43',
                  fontFamily: 'Source Sans Pro',
                  fontSize: '14px',
                  fontWeight: '600',
                  lineHeight: '24px',
                  background: 'var(--LIGHT-GREY, #F0F0F0) !important',
                  paddingLeft:'0px',
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row, index) => {
            return (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={index}
                sx={{
                  color: '#303C43',
                  '& .MuiTableCell-root': {
                    color: '#303C43',
                    fontFamily: 'Source Sans Pro !important',
                    fontSize: '14px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    paddingLeft: '0px',
                  },
                }}
              >
                <>
                  <TableCell padding="checkbox">
                    <Checkbox 
                      color="primary"
                      checked={checked[index]} // Bind each checkbox to the corresponding state
                      sx={{ paddingLeft: '16px' }} 
                      onChange={(event) => handleCheckboxChange(event, index)} // Handle individual checkbox change
                    />
                  </TableCell>

                  <TableCell
                    component="th"
                    //   id={labelId}
                    scope="row"
                    padding="none"
                    align={'left'}
                  >
                    <Stack spacing={2} direction="row" alignItems={'center'}>
                      <Box
                        width={'11%'}
                        className="chip"
                        sx={{
                          backgroundColor: `#D0D6D7`,
                          backgroundColor: `rgb(${row['target_color_rgb'][0]}, ${row['target_color_rgb'][1]}, ${row['target_color_rgb'][2]})`,
                          border: `1px solid #D0D6D7`,
                          width: '20px',
                          height: '20px',
                        }}
                      >
                      </Box>     
                      <Box>                 
                        <SplitText text={ row['target_color_name']} chunk={32} />
                      </Box>
                    </Stack>
                  </TableCell>

                  <TableCell align={'left'}>{ row['color_category'] == 'N/a' ? 'NA': row['color_category'] }

                  </TableCell>

                  <TableCell
                    component="th"
                    //   id={labelId}
                    scope="row"
                    padding="none"
                    align={'left'}
                  >
                    <Stack spacing={2} direction="row" alignItems={'center'}>

                      { 
                        row['nearest']? (
                         <Box 
                         width={'11%'}
                         className="chip"
                         sx={{
                           backgroundColor: `rgb(${row['nearest'][0]}, ${row['nearest'][1]}, ${row['nearest'][2]})`,
                           border: `1px solid #D0D6D7`,
                           width: '20px',
                           height: '20px',
                         }}
                       ></Box>

                      ): '' }
                     


                      {/* <Box>
                        <Link href="#">{row['NEAREST']}</Link>
                      </Box> */}


                    </Stack>
                  </TableCell>
                  <TableCell align={'left'}>{row['dE*']}</TableCell>
                  <TableCell align={'left'}>
                    {
                      row['result']?(
                        <Box >
                          <img src={OkIcon} class="imageOk"/>
                          <span class="textOk">OK</span> 
                        </Box>
                      ): 
                        <Box>
                          <img src={ NotIcon } class="imageOk"/>
                          <span class="textOk">NOK</span> 
                        </Box>

                      }
                  </TableCell>
                </>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
